import filtersRedux from './build';

const { initialState } = filtersRedux;

export default initialState;